import getStore from '../store/Store';
import { FeatureName } from '../store/featureDefinitions';

export default function isFeatureEnabled(feature: FeatureName): boolean {
    return getStore().featureFlags.get(feature.toLowerCase()) || false;
}
